// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/*
  We write styles for sidebar menu component (menulayout.js)
*/

*,
::after,
::before,
body {
  box-sizing: border-box;
}

.drawer ul,
body {
  padding: 0;
  margin: 0;
}

.drawer ul li {
  list-style: none;
}

.drawer a {
  text-decoration: none;
  color: inherit;
  /* background-color: var(--appcontent-bg-layer-color); */
}

.drawer .MuiDrawer-paper {
  top: unset;
}

.drawer .MuiPaper-root {
  background-color: var(--appcontent-bg-layer-color);
  white-space: nowrap;
}

.drawer_open {
  width: 17rem;
}

.drawer__mainmenu__navgroup {
  background-color: var(--navbar-group-color);
  margin-bottom: 3rem;
  box-shadow: 0px -1px 0px var(--button-disabled-color);
}

.drawer .drawer_open .PageHeader-root {
  padding: 0rem 15rem;
}

.drawer .drawer_close .PageHeader-root {
  padding: 0rem 4rem;
}

.drawer_close {
  width: 3.5625rem;
}

.muidrawer_open .MuiPaper-root {
  width: 268px;
  /* increased 8px as width of drawer increased 8px */
  box-shadow: 1px 0px 0px rgb(182 182 182 / 0%);
}

.muidrawer_close .MuiPaper-root {
  width: 4rem;
  overflow-x: hidden;
}

.drawer__toggle .MuiIconButton-root {
  padding: 10px 16px;
}

.drawer .MuiListItemIcon-root {
  min-width: 2.3rem;
  padding-left: 8px;
}

/* .drawer .muidrawer_open .MuiListItem-gutters {
  padding: 21.214px 10px;
} */

.drawer .muidrawer_open .MuiListItem-gutters.drawer__submenu_item {
  padding: 0rem 10px !important;
}

.drawer .drawer_close .MuiListItem-gutters {
  padding: 0.6rem 1rem;
}

.drawer__submenu_item.active,
.drawer__submenu_item.active:hover {
  text-decoration: none;
}

.drawer__submenu_item.active::before,
.drawer__mainmenu_item.active::before {
  background-color: var(--accent-color);
  bottom: 0;
  content: '';
  left: 0;
  position: absolute;
  top: 0;
  width: 0.3125rem;
  margin: 0.2rem;
}

.drawer__mainmenu_item,
.main_menu_items,
.divrecent .drawer__submenu_item,
.divPinned .drawer__submenu_item {
  height: 35px;
}

.drawer .MuiDrawer-paperAnchorDockedLeft {
  border: none;
}

.drawer.drawer_open,
.drawer.drawer_open:not(
    #EntityPopup,
    #OptionSetPopup,
    #EntityFieldPopup,
    #actionbarpanel,
    .bodypage.nonnps
  ),
.drawer.drawer_open
  ~ div:not(
    #EntityPopup,
    #OptionSetPopup,
    #EntityFieldPopup,
    #actionbarpanel,
    .bodypage.nonnps
  ) {
  position: relative;
  left: 216px;
  width: calc(96.5% - 224px);
  margin-left: 52px;
  /* increased 8px as width of drawer increased 8px */
}

.drawer.drawer_open ~ .bodypage.nonnps {
  position: relative;
  left: 216px;
  width: calc(96.5% - 183px);
  margin-left: 44px;
}

.drawer.drawer_close,
.drawer.drawer_close:not(
    #EntityPopup,
    #OptionSetPopup,
    #EntityFieldPopup,
    #actionbarpanel,
    .bodypage.nonnps
  ),
.drawer.drawer_close
  ~ div:not(
    #EntityPopup,
    #OptionSetPopup,
    #EntityFieldPopup,
    #actionbarpanel,
    .bodypage.nonnps
  ) {
  position: relative;
  left: 4rem;
  width: calc(98% - 3.34rem);
}

.drawer.drawer_close ~ .bodypage.nonnps {
  position: relative;
  left: 4rem;
  width: calc(98% - 16px);
}

.drawer.drawer_close ~ .actionbar {
  margin-left: 3.34rem;
}

.drawer.drawer_open ~ .actionbar {
  margin-left: 15rem;
}

.PageHeader-root,
.PageHeader-root + div {
  transition: all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
  overflow: auto;
}

.actionbar,
.actionbar + div {
  transition: all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
}

.drawer .drawer_open .drawer__submenu_item.MuiListItem-gutters {
  padding-left: 3.5rem;
}

.drawer .menu li {
  display: inline-block;
  position: relative;
}

.drawer__mainmenu a.drawer__mainmenu_item:hover > .submenu,
.drawer .menu li.dropdown:hover > .submenu,
.drawer__mainmenu .drawer__mainmenu_item:hover > .submenu,
.drawer__mainmenu.menu:hover > .submenu-items,
.drawer__submenu.level_1:hover > .submenu-items,
.drawer .menu,
.MuiListItem-button:hover .imageicon {
  display: block;
}

.drawer__mainmenu menu .drawer .menu li a {
  display: block;
  padding: 12px 8px;
}

.drawer .menu li a:hover {
  border-left: 2px solid var(--primary-color);

  background: var(--carddatatitlebordercolor);
  color: var(--listHeaderFontColor);
  cursor: pointer;
  font-weight: var(--header-FontWeight);
}

.drawer .menu :where(.levelOne, .levelTwo).opened li:hover {
  background: var(--carddatatitlebordercolor);
  color: var(--listHeaderFontColor);
  cursor: pointer;
  font-weight: var(--header-FontWeight);
}

.drawer .menu .submenu,
.drawer .menu .submenu-items {
  display: none;
}

.drawer .submenu-items {
  margin: 0px;
  padding: 0px;
  position: fixed;
  background-color: var(--tooltipFontColor);
  box-shadow: 2px 2px 5px 2px var(--menuLayoutBoxShadow);
  left: 0.2rem;
  list-style-type: none;
  display: block;
  width: 17.1875rem;
  z-index: 1;
  max-height: 2.1875rem;
}

.drawer .submenu__header {
  padding: 10px 8px;
  border-bottom: 1px solid rgb(0, 0, 0, 0.2);
  font-weight: var(--header-FontWeight);
  font-family: var(--default-FontName);
}

.drawer .submenu {
  margin: 0px;
  padding: 0px;
  position: fixed;
  background-color: var(--tooltipFontColor);
  box-shadow: 2px 2px 5px 2px var(--menuLayoutBoxShadow);
  left: 3.34rem;
  list-style-type: none;
  display: block;
  width: 12.5rem;
  bottom: 0.25rem;
}

.drawer .submenu li {
  display: block;
}

.drawer .submenu li a {
  font-family: var(--default-FontName);
  color: var(--listHeaderFontColor);
  margin-bottom: 1px;
  text-decoration: none;
  padding-left: 2rem;
}

.drawer .menu .submenu > li.dropdown:hover > .submenu {
  display: block;
}

.drawer .menu .submenu .submenu {
  position: absolute;
  left: 200px;
  top: 0px;
}

.drawer_ {
  flex-grow: 1;
}

.drawer_ .navsectionMain .MuiTypography-body1 {
  white-space: normal;
  font-family: var(--default-FontName);
  font-size: var(--additionalTabSideHead);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
}

.drawer_ .selected_Items .MuiTypography-body1 {
  white-space: normal;
  font-family: var(--default-FontName);
  font-size: var(--default-FontSize);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
}

.drawer .MuiSvgIcon-root {
  width: 1.5rem;
  height: 1.5rem;
}

.imageicon {
  height: 1.25rem;
  width: 1.5rem;
  padding: 0rem 0.19rem 0rem 0rem;
  filter: opacity(0.5) drop-shadow(0 0 0 var(--navbar-Icon-color));
  cursor: pointer;
}

.__padding {
  padding-left: 1rem !important;
}

#lock-menu :hover {
  cursor: pointer;
}

.sidebar-brand-title {
  margin: 0rem 0.63rem 0.4375rem;
  margin: 0vw 0.52vw;
  font-size: var(--default-FontSize);
  line-height: 1.75rem;
  color: var(--navbar-text-color);
  font-family: var(--default-FontName);
  font-style: normal;
  align-self: center;
  font-weight: var(--header-FontWeight);
  letter-spacing: 0.05vw;
  width: 11.25rem;
  text-align: left;
  padding: 0rem 0rem 0.63rem 0rem;
}

.sidebar-brand {
  display: flex;
  margin: 1rem;
}

.pinnedList {
  display: grid;
}

.pinicon {
  height: 1.25rem;
  width: 1.25rem;
  padding: 0rem 0.19rem 0rem 0rem;
  filter: opacity(0.5) drop-shadow(0 0 0 var(--navbar-Icon-color));
  cursor: pointer;
}

.piniconMain {
  height: 1.25rem;
  width: 1.25rem;
  padding: 0rem 0.19rem 0rem 0rem;
  filter: opacity(0.5) drop-shadow(0 0 0 var(--navbar-Icon-color));
}

.divPinned {
  max-height: 20.625rem;
  overflow: auto;
  font-family: var(--default-FontName);
  font-size: var(--default-FontSize);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
}

.recentList .recentListitem {
  padding-left: 1.56rem;
  font-family: var(--default-FontName);
  font-size: var(--default-FontSize);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
}

.recentList {
  display: grid;
  font-family: var(--default-FontName);
  font-size: var(--default-FontSize);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
}

.divrecent {
  max-height: 20.625rem;
  overflow: auto;
  font-family: var(--default-FontName);
  font-size: var(--default-FontSize);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
}

.pinnedList .pinnedListitem {
  padding-left: 1.56rem;
  font-family: var(--default-FontName);
  font-size: var(--default-FontSize);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
}

.MuiListItemText-root.navsection.dynamic {
  margin-top: 0.15rem;
  margin-bottom: 0.15rem;
}

.selected_Items {
  display: flex;
  justify-content: center;
  align-content: center;
}

a.drawer__submenu_item:hover > .submenu-items {
  display: block;
}

a.drawer__submenu_item {
  min-height: 2.1875rem;
}

a.drawer__submenu_item:not(.close_drawer) {
  max-height: fit-content !important;
}

a.drawer__submenu_item.close_drawer {
  max-height: 2.1875rem;
}

a.drawer__submenu_item.close_drawer ul.submenu-items {
  max-height: fit-content;
}

.drawer_ {
  display: flex;
  flex-flow: column;
  width: 255px;
  /* increased 8px as parent menu shows ellipsis default view */
  padding-left: 5px;
}

.drawer_ .drawer__mainmenu.menu {
  display: flex;
  flex-flow: column;
  gap: 0.879rem;
}

.drawer_ .drawer__mainmenu.menu .MuiDivider-root {
  height: 0.01rem;
}

.drawer .menu .group__Items {
  max-height: 35rem;
  overflow: auto;
}

/* @media (min-height: 901px) and (max-height: 1080px) { */
.drawer .MuiPaper-root.MuiDrawer-paper {
  z-index: 997;
  /* margin-top: 50px; */
  height: 70vh;
  overflow-y: hidden;
}

/* } */

.drawer .MuiPaper-root.MuiDrawer-paper:hover {
  overflow-y: auto;
}

.drawer .MuiDrawer-root .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar {
  width: 0.4em;
  background-color: var(--appcontent-bg-color);
}

.drawer .MuiDrawer-root .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar,
.drawer
  .MuiDrawer-root
  .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar-track {
  margin-top: 50px;
  /* background-color: var(--appcontent-bg-color); */
  margin-bottom: 40px;
}

.drawer .MuiDrawer-root .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar,
.drawer
  .MuiDrawer-root
  .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar-thumb:start {
  margin-top: 50px;
}

.drawer .MuiDrawer-root .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar,
.drawer
  .MuiDrawer-root
  .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar-thumb {
  overflow: visible;
  border-radius: 4px;
  background-color: transparent;
}

/* margin-top:30px */

.drawer
  .MuiDrawer-root
  .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}

.drawer .MuiDrawer-root .MuiPaper-root.MuiDrawer-paper {
  /* Firefox */
  scrollbar-width: thin;
  /* IE and Edge */
  -ms-overflow-style: none;
}

.drawer_close .submenu-items .selected_Items .MuiListItemText-root {
  margin-top: 0rem;
  margin-bottom: 0rem;
}

.drawer_ .drawer__submenu {
  margin-top: 0.125rem;
}

.StaticItem {
  margin-bottom: -0.2937rem;
  /* margin-left: 25px; */
  background-color: var(--appcontent-bg-layer-color);
  margin-top: -18px;
}

.DynamicItem {
  margin-bottom: -0.0937rem;
}

.divrecent .imageicon,
.divPinned .imageicon {
  display: none;
}

.drawer .drawer__mainmenu a.drawer__mainmenu_item.active {
  height: 47.5px;
}

.firstmenu {
  height: 0px;
}

.MuiButtonBase-root.MuiListItem-root:hover {
  background-color: var(--appcontent-bg-layer-color);
}

.MuiButtonBase-root.MuiListItemButton-root:hover {
  background-color: var(--appcontent-bg-color);
}

.outeranchor,
.outeranchorgroup {
  margin-left: -18px;
  margin-left: -17px;
}

.drawer .outeranchor a,
.drawer .outeranchorgroup a {
  height: 47.5px;
}

.Menuitemstyle.activemenu {
  color: var(--button-color);
}
.levelTwo .Menuitemstyle.activemenu {
  color: var(--button-color);
}

.Menuitemstyle.inactivemenu {
  color: var(--submenufontcolour);
}

.outeranchorgroup.opened,
.outeranchor.active {
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  position: relative;
  background-color: var(--appcontent-bg-color);
}

.MenuItemgroup {
  padding-bottom: 5%;
  margin-top: -6.5%;
  width: 250px;
}
.levelTwo .MenuItemgroup {
  padding-bottom: 2.5%;
  padding-top: 2.5%;
}
.subitem {
  padding-bottom: 0px !important;
  transition: 2s linear;
}

.Menuitemstyle .MuiTypography-root {
  font-size: var(--additionalTabSideHead);
  font-family: var(--default-FontName);
  font-weight: var(--header-FontWeight);
  margin-left: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subMenuitemstyle .MuiTypography-root {
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--submenufontcolour);
}
.drawer .levelTwo.outeranchorgroup .Menuitemstyle .MuiTypography-root {
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--submenufontcolour);
}
.drawer
  .levelTwo.outeranchorgroup
  .Menuitemstyle.activemenu
  .MuiTypography-root {
  color: var(--listHeaderFontColor);
  font-weight: var(--header-FontWeight);
}
.drawer .levelTwo.outeranchorgroup {
  margin-left: 0px;
}
.drawer
  .levelTwo.outeranchorgroup
  .MuiCollapse-root
  .subMenuitemstyle
  .MuiTypography-root {
  margin-left: 57px;
}
.hide-title-bar .drawer .MuiPaper-root.MuiDrawer-paper {
  height: 80vh;
}
.drawer .circleHighlihtThirdLevelMenu {
  background-color: var(--listHeaderFontColor);
  border-radius: 50%;
  width: 6px;
  height: 6px;
}
.drawer .circleHighlihtThirdLevelMenu.hide {
  background-color: var(--appcontent-bg-color);
}
.drawer .thirdLevelMenu {
  display: grid;
  grid-template-columns: 8px 1fr;
  align-items: center;
  gap: 10px;
  margin-left: 4px;
}
.drawer .levelTwo.outeranchorgroup a {
  height: auto;
  gap: 5px;
  padding-left: 53px;
  padding-right: 6px;
}
.drawer .levelTwo.outeranchorgroup li {
  height: auto;
  gap: 5px;
  padding-left: 53px;
  display: grid;
  grid-template-columns: 1fr auto;
  padding-right: 6px;
}
.drawer p.menuDisplayText {
  margin: 0px !important;
}
.drawer .menuDisplayText {
  overflow: hidden;
  text-overflow: ellipsis;
}
.drawer :is(.levelOne, .levelTwo) .MuiListItem-root {
  display: grid;
  grid-template-columns: auto 1fr auto;
  height: 47.5px;
  cursor: pointer;
  gap: 0px !important;
}
.drawer .outeranchor li {
  display: grid;
  grid-template-columns: auto 1fr;
  height: 47.5px;
  cursor: pointer;
}
.outeranchorgroup .MuiCollapse-root .subMenuitemstyle .MuiTypography-root {
  margin: unset;
  margin-left: 57px;
}

.drawer .drawer__mainmenu a.drawer__mainmenu_item.activeMenugroupradius {
  height: 47.5px;
}

.previousmenuindex1 {
  border-bottom-right-radius: 6px;
}

.subMenuitemstyle.active .MuiTypography-root {
  color: var(--selectedSubmenu-fontColor);
  font-weight: var(--header-FontWeight);
  font-style: normal;
}

.outeranchorgroup .MuiListItem-root,
.outeranchor .MuiListItem-root {
  padding-top: 4px;
  padding-bottom: 4px;
}

.expandmoreIcon,
.expandlessIcon {
  color: var(--submenufontcolour);
}

.MuiCollapse-root
  .MuiCollapse-wrapper
  .MuiCollapse-wrapperInner
  .MuiButtonBase-root {
  display: flex;
  text-align: left;
  align-items: flex-start;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: unset;
}

.MuiListItem-root .MuiListItemText-root.homemenu {
  margin-top: 6px;
}

.MenuItemgroup
  .MuiCollapse-wrapper.MuiCollapse-vertical
  .MuiCollapse-wrapperInner
  .subitem
  .subMenuIndex0 {
  padding-top: 12px;
}

.confirmPopupTitle {
  font-size: var(--dialogTitleFontSize);
  font-family: var(--default-FontName);
  color: var(--default-FontColour);
  font-weight: var(--dialogTitleFontWeight);
  margin-block-start: 0px;
  margin-block-end: 0px;
}

.confirmPopupContent {
  font-size: var(--dialogContentFontSize);
  font-family: var(--default-FontName);
  color: var(--default-FontColour);
  font-weight: var(--dialogContentFontWeight);
  margin-block-start: 0px;
  margin-block-end: 0px;
}

.drawer .MuiDrawer-root .MuiPaper-root .MuiDivider-root {
  border-color: var(--appcontent-bg-layer-color);
}

.drawer__mainmenu .outeranchorgroup .disableMenu {
  display: none !important;
  pointer-events: none;
  color: var(--disableMenuColor);
}
.drawer__mainmenu .outeranchorgroup .disableMenuAccess,
.outeranchor .disableMenuAccess {
  pointer-events: none;
  color: var(--disableMenuColor);
  opacity: 0.5;
}
.drawer__mainmenu .expandableIcon {
  margin-top: 16px;
  padding-left: 4px;
  margin-bottom: 10px;
}
.drawer__mainmenu .expandableIcon svg {
  width: 30px;
  height: 30px;
  color: var(--secondary-FontColour);
  cursor: pointer;
}
.drawer.drawer_close .drawer_ {
  width: 49px;
}
.drawer.drawer_close
  .MuiSvgIcon-root:not(.drawer.drawer_close .expandableIcon .MuiSvgIcon-root),
.drawer.drawer_close .subitem {
  display: none;
}

@media screen and (max-width: 1370px) {
  .staticMenus,
  .staticMenusIcon {
    bottom: 6vh;
  }
}

@media screen and (min-width: 1371px) {
  .staticMenus,
  .staticMenusIcon {
    bottom: 8vh;
  }
}

.staticMenusIcon {
  margin-left: -52px;
}

.staticMenus {
  width: 225px;
  margin-left: -248px;
}

.staticMenus,
.staticMenusIcon {
  z-index: 1000;
  position: fixed;
  cursor: pointer;
}

.drawer .MuiDrawer-root.nonnps .MuiPaper-root {
  height: 93vh;
}

.nonnps ~ .drawer .MuiPaper-root,
.nonnps ~ .drawer .MuiPaper-root .StaticItem {
  background-color: var(--whiteColour) !important;
}
.subMenuitemstext1 {
  margin: unset;
  padding-left: 90px !important;
}
.subMenuitemstext1 .MuiTypography-body1 {
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--submenufontcolour);
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.outeranchor .subMenuitemliststyle {
  margin: unset;
  padding-left: 75px !important;
}
.Menuitemliststyle.activemenu .MuiTypography-root {
  color: var(--selectedSubmenu-fontColor);
  font-weight: var(--header-FontWeight);
  font-style: normal;
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
}

.Menuitemliststyle.activemenu .MuiSvgIcon-root {
  color: var(--selectedSubmenu-fontColor);
}

.Menuitemliststyle.activemenu .MuiSvgIcon-root path {
  fill: var(--selectedSubmenu-fontColor);
}

.Menuitemliststyle .MuiTypography-root {
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--submenufontcolour);
}

.Menuitemliststyle.inactivemenu {
  color: var(--submenufontcolour);
}
@media screen and ((max-width: 1366px)) {
  .drawer.drawer_open,
  .drawer.drawer_open:not(
      #EntityPopup,
      #OptionSetPopup,
      #EntityFieldPopup,
      #actionbarpanel,
      .bodypage.nonnps
    ),
  .drawer.drawer_open
    ~ div:not(
      #EntityPopup,
      #OptionSetPopup,
      #EntityFieldPopup,
      #actionbarpanel,
      .bodypage.nonnps
    ) {
    width: calc(96.5% - 240px);
  }
}
@media screen and ((max-width: 1366px)) {
  .drawer.drawer_open,
  .drawer.drawer_open:not(
      #EntityPopup,
      #OptionSetPopup,
      #EntityFieldPopup,
      #actionbarpanel,
      .bodypage.nonnps
    ),
  .drawer.drawer_open
    ~ div:not(
      #EntityPopup,
      #OptionSetPopup,
      #EntityFieldPopup,
      #actionbarpanel,
      .bodypage.nonnps
    ) {
    width: calc(96.5% - 240px);
  }
}
@media screen and (min-width: 1850px) {
  .drawer .orgReport {
    height: 70px !important;
  }
  .drawer .MuiTypography-root {
    white-space: pre-wrap !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/components/custom/menuLayout/MenuLayout.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;;CAEC;;AAED;;;;EAIE,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mDAAmD;EACnD,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;EAgBE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;EAgBE,kBAAkB;EAClB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,sDAAsD;EACtD,cAAc;AAChB;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;;EAE3C,2CAA2C;EAC3C,iCAAiC;EACjC,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,eAAe;EACf,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,sDAAsD;EACtD,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,sDAAsD;EACtD,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;EACvC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,gEAAgE;EAChE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;EACpB,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,gEAAgE;EAChE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,gEAAgE;AAClE;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,MAAM;;AAEN;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;;;;EAIE,gBAAgB;EAChB,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;EAIE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,oBAAoB;;AAEpB;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,+BAA+B;AACjC;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,+BAA+B;AACjC;AACA;;;;EAIE,iCAAiC;EACjC,qCAAqC;AACvC;AACA;EACE,gBAAgB;AAClB;AACA;;;;;EAKE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;;;EAIE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,gCAAgC;EAChC,yCAAyC;EACzC,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,gCAAgC;EAChC,2CAA2C;EAC3C,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,8BAA8B;AAChC;AACA;;EAEE,oBAAoB;EACpB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;;;EAGE,aAAa;AACf;;AAEA;EACE;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE;;;;;;;;;;;;;;;;IAgBE,0BAA0B;EAC5B;AACF;AACA;EACE;;;;;;;;;;;;;;;;IAgBE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,gCAAgC;EAClC;AACF","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n\n/*\n  We write styles for sidebar menu component (menulayout.js)\n*/\n\n*,\n::after,\n::before,\nbody {\n  box-sizing: border-box;\n}\n\n.drawer ul,\nbody {\n  padding: 0;\n  margin: 0;\n}\n\n.drawer ul li {\n  list-style: none;\n}\n\n.drawer a {\n  text-decoration: none;\n  color: inherit;\n  /* background-color: var(--appcontent-bg-layer-color); */\n}\n\n.drawer .MuiDrawer-paper {\n  top: unset;\n}\n\n.drawer .MuiPaper-root {\n  background-color: var(--appcontent-bg-layer-color);\n  white-space: nowrap;\n}\n\n.drawer_open {\n  width: 17rem;\n}\n\n.drawer__mainmenu__navgroup {\n  background-color: var(--navbar-group-color);\n  margin-bottom: 3rem;\n  box-shadow: 0px -1px 0px var(--button-disabled-color);\n}\n\n.drawer .drawer_open .PageHeader-root {\n  padding: 0rem 15rem;\n}\n\n.drawer .drawer_close .PageHeader-root {\n  padding: 0rem 4rem;\n}\n\n.drawer_close {\n  width: 3.5625rem;\n}\n\n.muidrawer_open .MuiPaper-root {\n  width: 268px;\n  /* increased 8px as width of drawer increased 8px */\n  box-shadow: 1px 0px 0px rgb(182 182 182 / 0%);\n}\n\n.muidrawer_close .MuiPaper-root {\n  width: 4rem;\n  overflow-x: hidden;\n}\n\n.drawer__toggle .MuiIconButton-root {\n  padding: 10px 16px;\n}\n\n.drawer .MuiListItemIcon-root {\n  min-width: 2.3rem;\n  padding-left: 8px;\n}\n\n/* .drawer .muidrawer_open .MuiListItem-gutters {\n  padding: 21.214px 10px;\n} */\n\n.drawer .muidrawer_open .MuiListItem-gutters.drawer__submenu_item {\n  padding: 0rem 10px !important;\n}\n\n.drawer .drawer_close .MuiListItem-gutters {\n  padding: 0.6rem 1rem;\n}\n\n.drawer__submenu_item.active,\n.drawer__submenu_item.active:hover {\n  text-decoration: none;\n}\n\n.drawer__submenu_item.active::before,\n.drawer__mainmenu_item.active::before {\n  background-color: var(--accent-color);\n  bottom: 0;\n  content: '';\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 0.3125rem;\n  margin: 0.2rem;\n}\n\n.drawer__mainmenu_item,\n.main_menu_items,\n.divrecent .drawer__submenu_item,\n.divPinned .drawer__submenu_item {\n  height: 35px;\n}\n\n.drawer .MuiDrawer-paperAnchorDockedLeft {\n  border: none;\n}\n\n.drawer.drawer_open,\n.drawer.drawer_open:not(\n    #EntityPopup,\n    #OptionSetPopup,\n    #EntityFieldPopup,\n    #actionbarpanel,\n    .bodypage.nonnps\n  ),\n.drawer.drawer_open\n  ~ div:not(\n    #EntityPopup,\n    #OptionSetPopup,\n    #EntityFieldPopup,\n    #actionbarpanel,\n    .bodypage.nonnps\n  ) {\n  position: relative;\n  left: 216px;\n  width: calc(96.5% - 224px);\n  margin-left: 52px;\n  /* increased 8px as width of drawer increased 8px */\n}\n\n.drawer.drawer_open ~ .bodypage.nonnps {\n  position: relative;\n  left: 216px;\n  width: calc(96.5% - 183px);\n  margin-left: 44px;\n}\n\n.drawer.drawer_close,\n.drawer.drawer_close:not(\n    #EntityPopup,\n    #OptionSetPopup,\n    #EntityFieldPopup,\n    #actionbarpanel,\n    .bodypage.nonnps\n  ),\n.drawer.drawer_close\n  ~ div:not(\n    #EntityPopup,\n    #OptionSetPopup,\n    #EntityFieldPopup,\n    #actionbarpanel,\n    .bodypage.nonnps\n  ) {\n  position: relative;\n  left: 4rem;\n  width: calc(98% - 3.34rem);\n}\n\n.drawer.drawer_close ~ .bodypage.nonnps {\n  position: relative;\n  left: 4rem;\n  width: calc(98% - 16px);\n}\n\n.drawer.drawer_close ~ .actionbar {\n  margin-left: 3.34rem;\n}\n\n.drawer.drawer_open ~ .actionbar {\n  margin-left: 15rem;\n}\n\n.PageHeader-root,\n.PageHeader-root + div {\n  transition: all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;\n  overflow: auto;\n}\n\n.actionbar,\n.actionbar + div {\n  transition: all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;\n}\n\n.drawer .drawer_open .drawer__submenu_item.MuiListItem-gutters {\n  padding-left: 3.5rem;\n}\n\n.drawer .menu li {\n  display: inline-block;\n  position: relative;\n}\n\n.drawer__mainmenu a.drawer__mainmenu_item:hover > .submenu,\n.drawer .menu li.dropdown:hover > .submenu,\n.drawer__mainmenu .drawer__mainmenu_item:hover > .submenu,\n.drawer__mainmenu.menu:hover > .submenu-items,\n.drawer__submenu.level_1:hover > .submenu-items,\n.drawer .menu,\n.MuiListItem-button:hover .imageicon {\n  display: block;\n}\n\n.drawer__mainmenu menu .drawer .menu li a {\n  display: block;\n  padding: 12px 8px;\n}\n\n.drawer .menu li a:hover {\n  border-left: 2px solid var(--primary-color);\n\n  background: var(--carddatatitlebordercolor);\n  color: var(--listHeaderFontColor);\n  cursor: pointer;\n  font-weight: var(--header-FontWeight);\n}\n\n.drawer .menu :where(.levelOne, .levelTwo).opened li:hover {\n  background: var(--carddatatitlebordercolor);\n  color: var(--listHeaderFontColor);\n  cursor: pointer;\n  font-weight: var(--header-FontWeight);\n}\n\n.drawer .menu .submenu,\n.drawer .menu .submenu-items {\n  display: none;\n}\n\n.drawer .submenu-items {\n  margin: 0px;\n  padding: 0px;\n  position: fixed;\n  background-color: var(--tooltipFontColor);\n  box-shadow: 2px 2px 5px 2px var(--menuLayoutBoxShadow);\n  left: 0.2rem;\n  list-style-type: none;\n  display: block;\n  width: 17.1875rem;\n  z-index: 1;\n  max-height: 2.1875rem;\n}\n\n.drawer .submenu__header {\n  padding: 10px 8px;\n  border-bottom: 1px solid rgb(0, 0, 0, 0.2);\n  font-weight: var(--header-FontWeight);\n  font-family: var(--default-FontName);\n}\n\n.drawer .submenu {\n  margin: 0px;\n  padding: 0px;\n  position: fixed;\n  background-color: var(--tooltipFontColor);\n  box-shadow: 2px 2px 5px 2px var(--menuLayoutBoxShadow);\n  left: 3.34rem;\n  list-style-type: none;\n  display: block;\n  width: 12.5rem;\n  bottom: 0.25rem;\n}\n\n.drawer .submenu li {\n  display: block;\n}\n\n.drawer .submenu li a {\n  font-family: var(--default-FontName);\n  color: var(--listHeaderFontColor);\n  margin-bottom: 1px;\n  text-decoration: none;\n  padding-left: 2rem;\n}\n\n.drawer .menu .submenu > li.dropdown:hover > .submenu {\n  display: block;\n}\n\n.drawer .menu .submenu .submenu {\n  position: absolute;\n  left: 200px;\n  top: 0px;\n}\n\n.drawer_ {\n  flex-grow: 1;\n}\n\n.drawer_ .navsectionMain .MuiTypography-body1 {\n  white-space: normal;\n  font-family: var(--default-FontName);\n  font-size: var(--additionalTabSideHead);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n}\n\n.drawer_ .selected_Items .MuiTypography-body1 {\n  white-space: normal;\n  font-family: var(--default-FontName);\n  font-size: var(--default-FontSize);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n}\n\n.drawer .MuiSvgIcon-root {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.imageicon {\n  height: 1.25rem;\n  width: 1.5rem;\n  padding: 0rem 0.19rem 0rem 0rem;\n  filter: opacity(0.5) drop-shadow(0 0 0 var(--navbar-Icon-color));\n  cursor: pointer;\n}\n\n.__padding {\n  padding-left: 1rem !important;\n}\n\n#lock-menu :hover {\n  cursor: pointer;\n}\n\n.sidebar-brand-title {\n  margin: 0rem 0.63rem 0.4375rem;\n  margin: 0vw 0.52vw;\n  font-size: var(--default-FontSize);\n  line-height: 1.75rem;\n  color: var(--navbar-text-color);\n  font-family: var(--default-FontName);\n  font-style: normal;\n  align-self: center;\n  font-weight: var(--header-FontWeight);\n  letter-spacing: 0.05vw;\n  width: 11.25rem;\n  text-align: left;\n  padding: 0rem 0rem 0.63rem 0rem;\n}\n\n.sidebar-brand {\n  display: flex;\n  margin: 1rem;\n}\n\n.pinnedList {\n  display: grid;\n}\n\n.pinicon {\n  height: 1.25rem;\n  width: 1.25rem;\n  padding: 0rem 0.19rem 0rem 0rem;\n  filter: opacity(0.5) drop-shadow(0 0 0 var(--navbar-Icon-color));\n  cursor: pointer;\n}\n\n.piniconMain {\n  height: 1.25rem;\n  width: 1.25rem;\n  padding: 0rem 0.19rem 0rem 0rem;\n  filter: opacity(0.5) drop-shadow(0 0 0 var(--navbar-Icon-color));\n}\n\n.divPinned {\n  max-height: 20.625rem;\n  overflow: auto;\n  font-family: var(--default-FontName);\n  font-size: var(--default-FontSize);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n}\n\n.recentList .recentListitem {\n  padding-left: 1.56rem;\n  font-family: var(--default-FontName);\n  font-size: var(--default-FontSize);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n}\n\n.recentList {\n  display: grid;\n  font-family: var(--default-FontName);\n  font-size: var(--default-FontSize);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n}\n\n.divrecent {\n  max-height: 20.625rem;\n  overflow: auto;\n  font-family: var(--default-FontName);\n  font-size: var(--default-FontSize);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n}\n\n.pinnedList .pinnedListitem {\n  padding-left: 1.56rem;\n  font-family: var(--default-FontName);\n  font-size: var(--default-FontSize);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n}\n\n.MuiListItemText-root.navsection.dynamic {\n  margin-top: 0.15rem;\n  margin-bottom: 0.15rem;\n}\n\n.selected_Items {\n  display: flex;\n  justify-content: center;\n  align-content: center;\n}\n\na.drawer__submenu_item:hover > .submenu-items {\n  display: block;\n}\n\na.drawer__submenu_item {\n  min-height: 2.1875rem;\n}\n\na.drawer__submenu_item:not(.close_drawer) {\n  max-height: fit-content !important;\n}\n\na.drawer__submenu_item.close_drawer {\n  max-height: 2.1875rem;\n}\n\na.drawer__submenu_item.close_drawer ul.submenu-items {\n  max-height: fit-content;\n}\n\n.drawer_ {\n  display: flex;\n  flex-flow: column;\n  width: 255px;\n  /* increased 8px as parent menu shows ellipsis default view */\n  padding-left: 5px;\n}\n\n.drawer_ .drawer__mainmenu.menu {\n  display: flex;\n  flex-flow: column;\n  gap: 0.879rem;\n}\n\n.drawer_ .drawer__mainmenu.menu .MuiDivider-root {\n  height: 0.01rem;\n}\n\n.drawer .menu .group__Items {\n  max-height: 35rem;\n  overflow: auto;\n}\n\n/* @media (min-height: 901px) and (max-height: 1080px) { */\n.drawer .MuiPaper-root.MuiDrawer-paper {\n  z-index: 997;\n  /* margin-top: 50px; */\n  height: 70vh;\n  overflow-y: hidden;\n}\n\n/* } */\n\n.drawer .MuiPaper-root.MuiDrawer-paper:hover {\n  overflow-y: auto;\n}\n\n.drawer .MuiDrawer-root .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar {\n  width: 0.4em;\n  background-color: var(--appcontent-bg-color);\n}\n\n.drawer .MuiDrawer-root .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar,\n.drawer\n  .MuiDrawer-root\n  .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar-track {\n  margin-top: 50px;\n  /* background-color: var(--appcontent-bg-color); */\n  margin-bottom: 40px;\n}\n\n.drawer .MuiDrawer-root .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar,\n.drawer\n  .MuiDrawer-root\n  .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar-thumb:start {\n  margin-top: 50px;\n}\n\n.drawer .MuiDrawer-root .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar,\n.drawer\n  .MuiDrawer-root\n  .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar-thumb {\n  overflow: visible;\n  border-radius: 4px;\n  background-color: transparent;\n}\n\n/* margin-top:30px */\n\n.drawer\n  .MuiDrawer-root\n  .MuiPaper-root.MuiDrawer-paper::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.drawer .MuiDrawer-root .MuiPaper-root.MuiDrawer-paper {\n  /* Firefox */\n  scrollbar-width: thin;\n  /* IE and Edge */\n  -ms-overflow-style: none;\n}\n\n.drawer_close .submenu-items .selected_Items .MuiListItemText-root {\n  margin-top: 0rem;\n  margin-bottom: 0rem;\n}\n\n.drawer_ .drawer__submenu {\n  margin-top: 0.125rem;\n}\n\n.StaticItem {\n  margin-bottom: -0.2937rem;\n  /* margin-left: 25px; */\n  background-color: var(--appcontent-bg-layer-color);\n  margin-top: -18px;\n}\n\n.DynamicItem {\n  margin-bottom: -0.0937rem;\n}\n\n.divrecent .imageicon,\n.divPinned .imageicon {\n  display: none;\n}\n\n.drawer .drawer__mainmenu a.drawer__mainmenu_item.active {\n  height: 47.5px;\n}\n\n.firstmenu {\n  height: 0px;\n}\n\n.MuiButtonBase-root.MuiListItem-root:hover {\n  background-color: var(--appcontent-bg-layer-color);\n}\n\n.MuiButtonBase-root.MuiListItemButton-root:hover {\n  background-color: var(--appcontent-bg-color);\n}\n\n.outeranchor,\n.outeranchorgroup {\n  margin-left: -18px;\n  margin-left: -17px;\n}\n\n.drawer .outeranchor a,\n.drawer .outeranchorgroup a {\n  height: 47.5px;\n}\n\n.Menuitemstyle.activemenu {\n  color: var(--button-color);\n}\n.levelTwo .Menuitemstyle.activemenu {\n  color: var(--button-color);\n}\n\n.Menuitemstyle.inactivemenu {\n  color: var(--submenufontcolour);\n}\n\n.outeranchorgroup.opened,\n.outeranchor.active {\n  border-top-right-radius: 30px;\n  border-bottom-right-radius: 30px;\n  position: relative;\n  background-color: var(--appcontent-bg-color);\n}\n\n.MenuItemgroup {\n  padding-bottom: 5%;\n  margin-top: -6.5%;\n  width: 250px;\n}\n.levelTwo .MenuItemgroup {\n  padding-bottom: 2.5%;\n  padding-top: 2.5%;\n}\n.subitem {\n  padding-bottom: 0px !important;\n  transition: 2s linear;\n}\n\n.Menuitemstyle .MuiTypography-root {\n  font-size: var(--additionalTabSideHead);\n  font-family: var(--default-FontName);\n  font-weight: var(--header-FontWeight);\n  margin-left: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.subMenuitemstyle .MuiTypography-root {\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--submenufontcolour);\n}\n.drawer .levelTwo.outeranchorgroup .Menuitemstyle .MuiTypography-root {\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--submenufontcolour);\n}\n.drawer\n  .levelTwo.outeranchorgroup\n  .Menuitemstyle.activemenu\n  .MuiTypography-root {\n  color: var(--listHeaderFontColor);\n  font-weight: var(--header-FontWeight);\n}\n.drawer .levelTwo.outeranchorgroup {\n  margin-left: 0px;\n}\n.drawer\n  .levelTwo.outeranchorgroup\n  .MuiCollapse-root\n  .subMenuitemstyle\n  .MuiTypography-root {\n  margin-left: 57px;\n}\n.hide-title-bar .drawer .MuiPaper-root.MuiDrawer-paper {\n  height: 80vh;\n}\n.drawer .circleHighlihtThirdLevelMenu {\n  background-color: var(--listHeaderFontColor);\n  border-radius: 50%;\n  width: 6px;\n  height: 6px;\n}\n.drawer .circleHighlihtThirdLevelMenu.hide {\n  background-color: var(--appcontent-bg-color);\n}\n.drawer .thirdLevelMenu {\n  display: grid;\n  grid-template-columns: 8px 1fr;\n  align-items: center;\n  gap: 10px;\n  margin-left: 4px;\n}\n.drawer .levelTwo.outeranchorgroup a {\n  height: auto;\n  gap: 5px;\n  padding-left: 53px;\n  padding-right: 6px;\n}\n.drawer .levelTwo.outeranchorgroup li {\n  height: auto;\n  gap: 5px;\n  padding-left: 53px;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  padding-right: 6px;\n}\n.drawer p.menuDisplayText {\n  margin: 0px !important;\n}\n.drawer .menuDisplayText {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.drawer :is(.levelOne, .levelTwo) .MuiListItem-root {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  height: 47.5px;\n  cursor: pointer;\n  gap: 0px !important;\n}\n.drawer .outeranchor li {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  height: 47.5px;\n  cursor: pointer;\n}\n.outeranchorgroup .MuiCollapse-root .subMenuitemstyle .MuiTypography-root {\n  margin: unset;\n  margin-left: 57px;\n}\n\n.drawer .drawer__mainmenu a.drawer__mainmenu_item.activeMenugroupradius {\n  height: 47.5px;\n}\n\n.previousmenuindex1 {\n  border-bottom-right-radius: 6px;\n}\n\n.subMenuitemstyle.active .MuiTypography-root {\n  color: var(--selectedSubmenu-fontColor);\n  font-weight: var(--header-FontWeight);\n  font-style: normal;\n}\n\n.outeranchorgroup .MuiListItem-root,\n.outeranchor .MuiListItem-root {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n\n.expandmoreIcon,\n.expandlessIcon {\n  color: var(--submenufontcolour);\n}\n\n.MuiCollapse-root\n  .MuiCollapse-wrapper\n  .MuiCollapse-wrapperInner\n  .MuiButtonBase-root {\n  display: flex;\n  text-align: left;\n  align-items: flex-start;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-left: unset;\n}\n\n.MuiListItem-root .MuiListItemText-root.homemenu {\n  margin-top: 6px;\n}\n\n.MenuItemgroup\n  .MuiCollapse-wrapper.MuiCollapse-vertical\n  .MuiCollapse-wrapperInner\n  .subitem\n  .subMenuIndex0 {\n  padding-top: 12px;\n}\n\n.confirmPopupTitle {\n  font-size: var(--dialogTitleFontSize);\n  font-family: var(--default-FontName);\n  color: var(--default-FontColour);\n  font-weight: var(--dialogTitleFontWeight);\n  margin-block-start: 0px;\n  margin-block-end: 0px;\n}\n\n.confirmPopupContent {\n  font-size: var(--dialogContentFontSize);\n  font-family: var(--default-FontName);\n  color: var(--default-FontColour);\n  font-weight: var(--dialogContentFontWeight);\n  margin-block-start: 0px;\n  margin-block-end: 0px;\n}\n\n.drawer .MuiDrawer-root .MuiPaper-root .MuiDivider-root {\n  border-color: var(--appcontent-bg-layer-color);\n}\n\n.drawer__mainmenu .outeranchorgroup .disableMenu {\n  display: none !important;\n  pointer-events: none;\n  color: var(--disableMenuColor);\n}\n.drawer__mainmenu .outeranchorgroup .disableMenuAccess,\n.outeranchor .disableMenuAccess {\n  pointer-events: none;\n  color: var(--disableMenuColor);\n  opacity: 0.5;\n}\n.drawer__mainmenu .expandableIcon {\n  margin-top: 16px;\n  padding-left: 4px;\n  margin-bottom: 10px;\n}\n.drawer__mainmenu .expandableIcon svg {\n  width: 30px;\n  height: 30px;\n  color: var(--secondary-FontColour);\n  cursor: pointer;\n}\n.drawer.drawer_close .drawer_ {\n  width: 49px;\n}\n.drawer.drawer_close\n  .MuiSvgIcon-root:not(.drawer.drawer_close .expandableIcon .MuiSvgIcon-root),\n.drawer.drawer_close .subitem {\n  display: none;\n}\n\n@media screen and (max-width: 1370px) {\n  .staticMenus,\n  .staticMenusIcon {\n    bottom: 6vh;\n  }\n}\n\n@media screen and (min-width: 1371px) {\n  .staticMenus,\n  .staticMenusIcon {\n    bottom: 8vh;\n  }\n}\n\n.staticMenusIcon {\n  margin-left: -52px;\n}\n\n.staticMenus {\n  width: 225px;\n  margin-left: -248px;\n}\n\n.staticMenus,\n.staticMenusIcon {\n  z-index: 1000;\n  position: fixed;\n  cursor: pointer;\n}\n\n.drawer .MuiDrawer-root.nonnps .MuiPaper-root {\n  height: 93vh;\n}\n\n.nonnps ~ .drawer .MuiPaper-root,\n.nonnps ~ .drawer .MuiPaper-root .StaticItem {\n  background-color: var(--whiteColour) !important;\n}\n.subMenuitemstext1 {\n  margin: unset;\n  padding-left: 90px !important;\n}\n.subMenuitemstext1 .MuiTypography-body1 {\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--submenufontcolour);\n  max-width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.outeranchor .subMenuitemliststyle {\n  margin: unset;\n  padding-left: 75px !important;\n}\n.Menuitemliststyle.activemenu .MuiTypography-root {\n  color: var(--selectedSubmenu-fontColor);\n  font-weight: var(--header-FontWeight);\n  font-style: normal;\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n}\n\n.Menuitemliststyle.activemenu .MuiSvgIcon-root {\n  color: var(--selectedSubmenu-fontColor);\n}\n\n.Menuitemliststyle.activemenu .MuiSvgIcon-root path {\n  fill: var(--selectedSubmenu-fontColor);\n}\n\n.Menuitemliststyle .MuiTypography-root {\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--submenufontcolour);\n}\n\n.Menuitemliststyle.inactivemenu {\n  color: var(--submenufontcolour);\n}\n@media screen and ((max-width: 1366px)) {\n  .drawer.drawer_open,\n  .drawer.drawer_open:not(\n      #EntityPopup,\n      #OptionSetPopup,\n      #EntityFieldPopup,\n      #actionbarpanel,\n      .bodypage.nonnps\n    ),\n  .drawer.drawer_open\n    ~ div:not(\n      #EntityPopup,\n      #OptionSetPopup,\n      #EntityFieldPopup,\n      #actionbarpanel,\n      .bodypage.nonnps\n    ) {\n    width: calc(96.5% - 240px);\n  }\n}\n@media screen and ((max-width: 1366px)) {\n  .drawer.drawer_open,\n  .drawer.drawer_open:not(\n      #EntityPopup,\n      #OptionSetPopup,\n      #EntityFieldPopup,\n      #actionbarpanel,\n      .bodypage.nonnps\n    ),\n  .drawer.drawer_open\n    ~ div:not(\n      #EntityPopup,\n      #OptionSetPopup,\n      #EntityFieldPopup,\n      #actionbarpanel,\n      .bodypage.nonnps\n    ) {\n    width: calc(96.5% - 240px);\n  }\n}\n@media screen and (min-width: 1850px) {\n  .drawer .orgReport {\n    height: 70px !important;\n  }\n  .drawer .MuiTypography-root {\n    white-space: pre-wrap !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
